import React, { useState } from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, Button, Snackbar, SnackbarContent, Alert } from '@mui/material';

import { supabase, host } from '../../supabaseClient';
import { useCode } from '../../contexts/Code';
import { useAuth } from '../../contexts/auth';

const RewardItem = ({ name, id, score,setScore, canUnlock }) => {
    const { code } = useCode();
    const { user } = useAuth();

    const [openDialog, setOpenDialog] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleClaimReward = async () => {
        try {

            const { data: userData, error: userError } = await supabase
                .from('users')
                .select('score')
                .eq('id', user.id)
                .single();

            if (userError) {
                setSnackbarMessage('Error al obtener el puntaje del usuario');
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
                return;
            }

            const currentUserScore = userData.score;
            const newScore = currentUserScore - score
            // Verificar si el usuario tiene suficiente puntaje para reclamar el premio
            if (currentUserScore < score) {
                setSnackbarMessage('El usuario no tiene suficiente puntaje para reclamar este premio');
                setSnackbarSeverity('warning');
                setOpenSnackbar(true);
                return;
            }

            // Actualizar el puntaje del usuario en la base de datos
            const { data: updateData, error: updateError } = await supabase
                .from('users')
                .update({ score: newScore })
                .eq('id', user.id)
                .single();
            
            setScore(newScore)

            if (updateError) {
                setSnackbarMessage('Error al actualizar el puntaje del usuario');
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
                return;
            }

            // Registrar el premio reclamado en la tabla rewards_claims
            const { data: claimData, error: claimError } = await supabase
                .from('rewards_claims')
                .insert([{ user: user.id, reward: id, company: code }]);

            if (claimError) {
                setSnackbarMessage('Error al reclamar el premio');
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
                return;
            }

            setSnackbarMessage('Premio reclamado exitosamente');
            setSnackbarSeverity('success');
            setOpenSnackbar(true);
        } catch (error) {
            setSnackbarMessage('Error al reclamar el premio');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        }

        setOpenDialog(false);
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };

    return (
        <>
            <ListItem disabled={!canUnlock} button onClick={() => setOpenDialog(true)}>
                <ListItemAvatar>
                    <Avatar
                        src={`${host}/storage/v1/object/public/rewards/${code}/${id}.png`}
                        style={{ width: '100px', height: '100px' }}
                    />
                </ListItemAvatar>
                <ListItemText
                    primary={name}
                    secondary={`${score} puntos`}
                    primaryTypographyProps={{ color: canUnlock ? 'inherit' : 'textSecondary' }}
                    secondaryTypographyProps={{ color: canUnlock ? 'inherit' : 'textSecondary' }}
                />
            </ListItem>
            <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Reclamar premio</DialogTitle>
                <DialogContent>
                    <p>¿Deseas reclamar este premio por {score} puntos?</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
                    <Button onClick={handleClaimReward} variant="contained" color="primary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleSnackbarClose}>
                <SnackbarContent sx={{ backgroundColor: snackbarSeverity === 'success' ? 'green' : 'red' }} message={snackbarMessage} />
            </Snackbar>
        </>
    );
};

export default RewardItem;
